import { connect } from 'react-redux';
import { onScreenChanged as _onScreenChanged } from '../../actions/Analytics';
import { selectLaunchDarklyUserKey } from '../../reducers/Configuration';
import AnalyticsListener from '../components/AnalyticsListener';
const mapStateToProps = state => {
  return {
    analytics: state.analytics,
    launchDarklyUserKey: selectLaunchDarklyUserKey(state.configuration)
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onScreenChanged: (source, attributes) => dispatch(_onScreenChanged(source, attributes))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsListener);